import { createContext } from "react";

export interface ShowMoreContextType {
  limit: number;
  isExpanded: boolean;
  toggleIsExpanded: () => void;
  totalItems: number;
  setTotalItems: (newState: number) => void;
}

const ShowMoreContext = createContext<ShowMoreContextType | undefined>(
  undefined,
);

export default ShowMoreContext;
